<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #grade="{ row }">
        <div>
          {{row.platform}}
        </div>
      </template>
      <template #handler="{ row }">
        <div>
           <el-button type="primary" size="small" @click="openEdit(row)">修改</el-button>
             <el-button type="primary" size="small" @click="openMember(row)">成员管理</el-button>
        </div>
      </template>
    </auto-table>

     <addGroup ref="add" @success="getList(1)"></addGroup>
     <editMember ref="member" @success="getList(1)"  />
  </div>
</template>

<script>

import {platformList,entryList} from '../knowledgeManage/components/dict'
import addGroup from './components/group/addGroup.vue';
import editMember from './components/group/editMember.vue';
export default {
    components:{
        addGroup,
        editMember
    },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "区域", value: "area",type: "custom" },
        { name: "级别", value: "grade", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
    };
  },

  mounted() {
     this.getList(1);
  },

  methods: {
  

    openMember(row){
        this.$refs.member.load(row)
    },
    openAdd() {
        this.$refs.add.open()
    },
     openEdit(row) {
        this.$refs.add.open(row)
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/chat/customerServiceGroup/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>